<p-confirmDialog key="reportinboxrecipients" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="reportinboxrecipientsconfirm" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div>
	<h4 style="text-align: center">Recipients{{ SelectedJob == undefined ? " - Select a Job -" : "" }}</h4>
</div>
<div *ngIf="SelectedJob != undefined">
	<!--Menu Bar-->
	<div class="lock-to-top" style="background-color: #ffffff">
		<!--Buttons-->
		<div class="button-body flex">
			<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>
			<button
				[disabled]="IsLoading() == true || (SelectedJob != undefined && SelectedJob.CanEdit == false)"
				class="btn btn-primary"
				style="margin-left: 5px"
				(click)="onAdd()"
			>
				Add Receipients
			</button>
			<button
				[disabled]="IsLoading() == true || (SelectedJob != undefined && SelectedJob.CanEdit == false)"
				class="btn btn-danger"
				style="margin-left: 5px"
				(click)="onDelete()"
			>
				Remove Recipients
			</button>
		</div>
	</div>

	<!--Table-->
	<div class="table-main-body">
		<p-table
			#mydt
			[value]="lstUser"
			[loading]="IsLoading() == true"
			[paginator]="true"
			[(rows)]="pagerows"
			[(first)]="pagefirst"
			[showCurrentPageReport]="true"
			[resizableColumns]="false"
			sortMode="multiple"
			styleClass="p-datatable-striped"
			selectionMode="multiple"
			[(selection)]="SelectedUsers"
			dataKey="UserID"
			(onRowSelect)="onRowSelect($event)"
			(onRowUnselect)="onRowUnselect($event)"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
			[rowsPerPageOptions]="[5, 10, 25, 50]"
		>
			<!--Headers-->
			<ng-template pTemplate="header">
				<!--Filter or Select from Dropdown-->
				<tr>
					<th></th>

					<!--Username-->
					<th>
						<p-columnFilter type="text" field="Username" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--FirstName-->
					<th>
						<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--LastName-->
					<th>
						<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--StaffID-->
					<th>
						<p-columnFilter type="text" field="StaffID" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--StaffTitle-->
					<th>
						<p-columnFilter type="text" field="StaffTitle" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--SchoolFullName-->
					<th>
						<p-columnFilter field="SchoolFullName" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterSchoolFullName
									[ngModel]="value"
									[options]="lstSchoolFullName"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>
				</tr>

				<!--Column Names-->
				<tr style="height: 4rem">
					<th>
						<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
					</th>

					<th pSortableColumn="Username">Username<p-sortIcon field="Username"></p-sortIcon></th>
					<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
					<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
					<th pSortableColumn="StaffID">Staff ID<p-sortIcon field="StaffID"></p-sortIcon></th>
					<th pSortableColumn="StaffTitle">Title<p-sortIcon field="StaffTitle"></p-sortIcon></th>
					<th pSortableColumn="SchoolFullName">Home School<p-sortIcon field="SchoolFullName"></p-sortIcon></th>
				</tr>
			</ng-template>

			<!--Data-->
			<ng-template pTemplate="body" let-User>
				<tr [pSelectableRow]="User">
					<td>
						<p-tableCheckbox [disabled]="IsLoading() == true" [pSelectableRow]="User" [value]="User"></p-tableCheckbox>
					</td>

					<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ User[col.field] }}
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>
